import  {request}  from './request';
const BASE = '/oa'
// 获取总数
export const getAnalysis = (data) => {
    return request(`${BASE}/customer/analysis`,"post",data)
}
// 客户上升榜
export const upgrade_customer = (data) => {
    return request(`${BASE}/customer/upgrade_customer`,"post",data)
}
// top客户分析-客户出货量排名
export const top_customer = (data) => {
    return request(`${BASE}/customer/top_customer`,"post",data)
}
// 查看客号详情
export const get_customer_detail = (data) => {
    return request(`${BASE}/customer/get_customer_detail`,"post",data)
}